<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">广泛的全球合作网络</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:38px;">广泛的全球合作网络</h3>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:38px;margin-top:0;">
          威马捷在中国（包括港澳台）的合作医疗机构超过2,000家，合作的服务代理超过1,000家，同时在全国以及港澳台各地区配有专业的医疗翻译陪同人员24小时为客户提供服务。<br/>
          在全球范围内与总部上市公司日本威马捷救援株式会社的全球救援中心（日本东京、泰国、新加坡、美国、英国、加拿大）联网，利用全球超过20,000家的合作网络，为客户的安心之旅保驾护航。
          <br/>
          我们的合作对象囊括了超过20,000家的全球医疗和3,000家以上的海外服务供应商，包含保险公司、医疗机构、大使馆、政府机构、救援包机公司、海外救援公司以及翻译服务公司、留学机构律师事务所、安保公司等等，覆盖全球200多个国家，并且我们的合作网络还在不断地强化和扩展。
        </p>
        <img class="pic-box"
             :src="worldnet1"
             alt="">
      </div>
      <h4 class="rescue-title">医疗机构及合作供应商数据库</h4>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:20px;">
          北京威马捷的信息数据库网罗了全球的服务供应商信息，利用这一系统，有效地解决海外客户中心的信息地域化差异问题，轻松实现不同时区的相互协作。
        </p>
        <div class="text-pic">
          <div class="text">
            <p class="more-case">从全球广域到指定地区局域，全方位的安心救援服务</p>
            <div>
              <span>•</span>
              <span>准确定位，并根据客户到医院的距离筛选。</span>
            </div>
            <div>
              <span>•</span>
              <span>根据客户需求，通过医院分类、功能及评价等条件迅速筛选。</span>
            </div>
            <div>
              <span>•</span>
              <span>分析比较筛选出的信息，综合判断后迅速制定最适合的救援方案。</span>
            </div>
            <div>
              <span>•</span>
              <span>为客户提供当地就诊常识及就医路线的专业建议，协助客户顺利就医。
              </span>
            </div>
          </div>
          <div class="pic">
            <img class="pic-box"
                 :src="worldnet3"
                 alt="">
          </div>
        </div>
        <img :src="worldnet4"
             style="display: block;margin: 0 auto;width:952px;"
             alt="">
      </div>
    </div>
  </div>
</template>
<script>
import worldnet1 from '@/assets/images/rescue/worldnet1.jpg'
import worldnet2 from '@/assets/images/rescue/worldnet2.jpg'
import worldnet3 from '@/assets/images/rescue/worldnet3.png'
import worldnet4 from '@/assets/images/rescue/worldnet4.png'
export default {
  data () {
    return {
      worldnet1,
      worldnet2,
      worldnet3,
      worldnet4
    }
  }
}
</script>
<style lang="less" scoped>
.text-pic {
  display: table;
  width: 909px;
  .text {
    float: left;
    .more-case {
      margin: 0;
      margin-bottom: 10px;
    }

    div {
      display: table;
      span:first-child {
        display: block;
        float: left;
        width: 25px;
        height: 32px;
        color: #ae1e10;
        font-size: 34px;
        line-height: 32px;
        text-align: left;
      }
      span:last-child {
        display: block;
        float: left;
        color: #333130;
        font-size: 16px;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .pic {
    float: right;
    img {
      width: 307px;
      height: 225px;
    }
  }
}
.pic-box {
  width: 908px;
  height: 472px;
  display: block;
  margin: auto;
}
.experience-part {
  border: none;
  overflow: hidden;
}
.world-depart {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 916px;
  margin: 0 auto;
  .depart1 {
    width: 368px;
  }
  .depart2 {
    width: 514px;
  }
  h5 {
    font-size: 24px;
    color: #333130;
    line-height: 40px;
    padding-left: 54px;
    background: url('../assets/images/rescue/worldnet5.png') no-repeat left
      center;
    margin-bottom: 20px;
  }
  p {
    font-size: 24px;
    color: #333130;
    line-height: 36px;
  }
}
.world-eye {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 900px;
  margin: 50px auto;
  img {
    width: 285px;
  }
  p {
    width: 600px;
    font-size: 20px;
    color: #333130;
    line-height: 36px;
  }
}
.world-tower {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 900px;
  margin: 0 auto 60px;
  img {
    flex: 1;
    width: 318px;
    margin: 0;
  }
  .tower-list {
    flex: 1;
    ul {
      margin-bottom: 50px;
    }
  }
}
.service-list li {
  font-size: 18px;
}
</style>